<template>
  <div>
    <!-- Checkboxes -->
    <div class="col-md">
      <b-form-group name="filter" label="Filter by Audience:">
        <b-form-checkbox-group plain v-model="selected" :options="options"/>
      </b-form-group>
    </div>

    <table class="c-location-modal__table table mb-6" id="results-table">
      <caption id="stroke-groups-caption" aria-live="polite" class="sr-only">
        Stroke Group Results
        <span id="captionUpdated" ref="captionUpdate">{{ captionMessage }}</span>
      </caption>
      <thead>
        <tr>
          <th
            tabindex="0"
            @keydown.enter="sort('name')"
            @click="sort('name')"
            v-bind:aria-sort="currentSortDir"
          >
            <span role="button">{{ translations.name }}</span>
          </th>
          <th
            tabindex="0"
            @keydown.enter="sort('virtualoption')"
            @click="sort('virtualoption')"
            v-bind:aria-sort="currentSortDir"
          >
            <span role="button">{{ translations.virtualOption }}</span>
          </th>
          <th
            tabindex="0"
            @keydown.enter="sort('city')"
            @click="sort('city')"
            v-bind:aria-sort="currentSortDir"
          >
            <span role="button">{{ translations.city }}</span>
          </th>
          <th
            tabindex="0"
            @keydown.enter="sort('state')"
            @click="sort('state')"
            v-bind:aria-sort="currentSortDir"
          >
            <span role="button">{{ translations.state }}</span>
          </th>
          <th
            tabindex="0"
            @keydown.enter="sort('zip')"
            @click="sort('zip')"
            v-bind:aria-sort="currentSortDir"
          >
            <span role="button">{{ translations.zipCode }}</span>
          </th>
          <!--<th role="button" tabindex="0" @keydown.enter="sort('type')" @click="sort('type')">{{ translations.type }}</th>-->
          <!--<th>{{ translations.city }}/{{ translations.state }}/{{ translations.zipCode }}</th>-->
        </tr>
      </thead>
      <tbody>
        <tr v-for="location in sortedName" v-bind:key="location.id">
          <td>
            <a
              :href="location.url"
              @click="locationClicked(location.url)"
              class="c-cta h-theme--red"
            >{{ location.name }}</a>
          </td>
          <td>{{ location.virtualoption }}</td>
          <td>{{ location.city }}</td>
          <td>{{ location.state }}</td>
          <td>{{ location.zip }}</td>
          <!--<td class="text-capitalize">{{ location.type }}</td>-->
          <!--<td>{{ location.city }}, {{ location.state }} {{ location.zip }}</td>-->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: "",
      selected: [],
      currentSort: "",
      currentSortDir: "ascending",
      options: [
        { text: "Survivors", value: "Survivors" },
        { text: "Caregivers", value: "Caregivers" },
        { text: "Medical Professionals", value: "Medical Professionals" }
      ],
      mylocations: [],
      captionMessage: "h"
    };
  },
  props: {
    locations: {
      type: Array,
      requires: true,
      default: []
    },
    translations: {
      type: Object,
      required: true
    },
    previousSearchedParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    validLocations: function() {
      return this.locations.filter(location => location.url !== "");
    },
    sortedName: function() {
      if (this.selected.length >= 1) {
        this.updateTableCaption();
        this.mylocations = this.locations.filter(location => {
          for (var i = 0; i < this.selected.length; i++) {
            if (location.audience.indexOf(this.selected[i]) > -1) {
              return location;
            }
          }
        });
      } else {
        this.mylocations = this.locations;
      }
      return this.mylocations.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "descending") modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
    audienceUrlQuery: function() {
      let query = "";
      if (this.selected.length > 0) {
        query = "";
        this.selected.forEach((item, i) => {
          query += "&audience=" + item;
        });
      }
      return query;
    }
  },
  methods: {
    sort: function(s) {
      if (s === this.currentSort) {
        this.currentSortDir =
          this.currentSortDir === "ascending" ? "descending" : "ascending";
      }
      this.currentSort = s;
      this.updateTableCaption();
    },
    updateTableCaption: function() {
      this.captionMessage =
        " (Sorted by " +
        this.$data.selected +
        ": " +
        this.$data.currentSortDir +
        ")";
    },
    handleLink(url) {
      window.location.href = url + '?' + this.audienceUrlQuery;
    },
    locationClicked(url) {

      let baseUrl = window.location.href;
      var search = {
        id: url,
        baseURI: baseUrl
      };
      localStorage.setItem("_aha.last-search", JSON.stringify(search));

      const data = localStorage.getItem('_aha.last-group-finder');
      if(data) {
        let sgoptions = JSON.parse(data);

        sgoptions.audience = this.selected;
        localStorage.setItem('_aha.last-group-finder', JSON.stringify(sgoptions));
      }
    },
    clearFilters: function() {
      this.selected = [];
    }
  },
  created() {
    if (this.previousSearchedParams.audience) {
      this.selected = this.previousSearchedParams.audience;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/stroke-group-selector-table.vue